import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import About from './components/About';
import Process from './components/Process';
import ServiceArea from './components/ServiceArea';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import QuoteForm from './components/QuoteForm';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <WhyChooseUs />
      <About />
      <Process />
      <ServiceArea />
      <Testimonials />
      <FAQ />
      <QuoteForm />
      <Footer />
      
      {/* Sticky Mobile CTA - Bottom Left Corner */}
      <div className="fixed bottom-6 left-6 z-50 lg:hidden">
        <a
          href="tel:7606257767"
          className="flex items-center gap-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-4 rounded-2xl shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 group"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl">
            <i className="ri-phone-fill text-xl"></i>
          </div>
          <div className="text-left">
            <div className="text-xs font-medium opacity-90 whitespace-nowrap">Call Now</div>
            <div className="text-sm font-bold whitespace-nowrap">(760) 625-7767</div>
          </div>
        </a>
      </div>

      {/* Floating Quote Button - Bottom Right Corner (Desktop & Mobile) */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="#quote-form"
          className="flex items-center justify-center w-16 h-16 bg-slate-900 text-white rounded-full shadow-2xl hover:bg-amber-500 transition-all duration-300 hover:scale-110 group"
        >
          <i className="ri-file-list-3-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}